// @ts-nocheck

import { fetchRequest, initialFetchListParams } from './index';
export type RoleListParams = {
  page?: number;
  pageSize?: number;
  [key: string]: unknown;
};

export const fetchRoles = async (
  params: RoleListParams = initialFetchListParams
) => await fetchRequest.get('/role', {
  ...initialFetchListParams,
  ...params
});
export const addRole = async role => {
  const added = await fetchRequest.post('/role', role);
  if (added) return added;
  throw new Error('Не удалось создать роль');
};
export const fetchRole = async (id, params = {}) => {
  const role = await fetchRequest.get(`/role/${id}`, params);
  if (role) return role;
  throw new Error('Не удалось получить роль');
};
export const updateRole = async role => {
  const updated = await fetchRequest.put('/role', role);
  if (updated) return updated;
  throw new Error('Не удалось обновить роль');
};
export const deleteRole = async id => {
  const deleted = await fetchRequest.delete(`/role/${id}`);
  if (deleted) return deleted;
  throw new Error('Не удалось удалить роль');
};
export default {
  fetchRoles,
  addRole,
  fetchRole,
  updateRole,
  deleteRole
};
